var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12 d-flex justify-content-between"},[_c('h1',{staticClass:"font-weight-bolder"},[_vm._t("title",[_vm._v(" "+_vm._s(_vm.title)+" ")])],2),_c('div',[_vm._t("actions")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }